import React from 'react'

import app from '../../../app.jsx'
import Acl from '../../../lib/acl.jsx'
import PageBase from '../../../common/page/page_base/page_base.jsx'
import PageHeader from '../../../theme/layout/page_header/page_header.jsx'
import { SettingsIcon } from '../../../common/layout/menu_icons/settings.jsx'

class BaseSettings extends PageBase {
  renderHeader () {
    const filter = this.data.filter || {}
    const isRoleAdmin = Acl.isRoleAdmin()

    const tabs = [
      ...(isRoleAdmin
        ? [
          {
            ident: 'setting-user',
            title: 'setting.userList.users',
            showFavourite: true
          }
        ]
        : []),
      {
        ident: 'setting-companyprofile',
        title: 'setting.companyProfile.companyProfile',
        showFavourite: true
      },
      ...(Acl.isPageAllowed('setting-project')
        ? [
          {
            ident: 'setting-project',
            title: 'setting.project.projectSetting',
            showFavourite: true
          }
        ]
        : []),
      {
        ident: 'setting-mailtemplate',
        title: 'setting.mailTemplate.titleMailTemplate',
        showFavourite: true
      },
      {
        ident: 'setting-pdftemplate',
        title: 'setting.pdfTemplate.titlePdfTemplate',
        showFavourite: true
      },
      {
        ident: 'setting-payment',
        title: 'setting.rateCard.contentTitle',
        showFavourite: true
      },
      {
        ident: 'setting-integration',
        title: 'setting.integration.contentTitle',
        showFavourite: true
      }
    ]

    // Hide subscription tab in Demo environment
    if (!app.isDemo && isRoleAdmin) {
      tabs.push({
        ident: 'setting-subscription',
        title: 'setting.subscription.title',
        showFavourite: true
      })
    }

    if (!app.isDemo && app.canGenerateDemoData()) {
      tabs.push({
        ident: 'setting-demodata',
        title: 'setting.demo.demoSetting',
        showFavourite: true
      })
    }

    // Hide taxrate for non USA teams or when quickbooks connected
    if (app.teamCountry === 'US' && !app.isQuickbookConnected()) {
      tabs.push({
        ident: 'setting-taxrate',
        title: 'setting.taxRate.settingTaxTitle',
        showFavourite: true
      })
    }

    const contentFilters = []
    if (this._pageIdent === 'setting-user') {
      contentFilters.push({
        ident: filter.filterType || 'active',
        title:
          filter.filterType === 'archieve'
            ? 'setting.setting.filterArchived'
            : 'setting.setting.filterActive'
      })
    }

    return (
      <PageHeader
        ref={this._references.pageHeader}
        title='setting.setting.titleSetting'
        icon={<SettingsIcon width={20} />}
        showTabs
        activeTab={this._pageIdent}
        favoriteTab={this._getUserFavoriteTab('settings') || 'setting-user'}
        tabs={tabs}
        contentFilters={contentFilters}
        showGridList={this._pageIdent === 'setting-user'}
        isGridActive={this.state.type === 'grid'}
        onContentFilterChange={this._onHeaderContentFilter.bind(this)}
        onTabChange={this._onHeaderTabChange.bind(this)}
        onGridListToggle={this._onHeaderGridListToggle.bind(this)}
        onToggleFavorite={this._onHeaderToggleFavorite.bind(this)}
      />
    )
  }

  _onHeaderTabChange (tab) {
    app.changePage(tab.ident)
  }

  _onHeaderToggleFavorite (tab) {
    this._updateUserStateFavorite('settings', tab.ident)
    this.setState({ dataDate: new Date() })
  }

  _onHeaderGridListToggle () {}

  _onHeaderContentFilter () {}
}

export default BaseSettings
